export default __webpack_public_path__ + "static/media/shift-left.03edf2b2.svg";